import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const QINETIC_IMPORT_API_NAME: string = 'qinetic_import';
export const QINETIC_IMPORT_API_ENDPOINT: string = environment.API_BASE_PATH + '/qinetic-import';

@Injectable({
  providedIn: 'root',
})
export class QineticImportService {
  create(upload: string): Observable<any> {
    const api_name: string = QINETIC_IMPORT_API_NAME;
    const path: string = '';
    const init = { response: true, body: { upload } };
    return from(API.post(api_name, path, init));
  }

  read(qinetic_import_id: string): Observable<any> {
    const api_name: string = QINETIC_IMPORT_API_NAME;
    const path: string = `/${qinetic_import_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }
}

export interface QineticImport {
  qinetic_import_id?: string;
  object?: string;
  status?: QineticImportStatus;
  csv_path?: string;
  failure_cause?: string;
  imported?: number;
  unprocessed?: number;
}

export enum QineticImportStatus {
  pending = 'pending',
  completed = 'completed',
  failed = 'failed',
}
